import React from "react";
import Header from "../components/Header";
import { Link } from "react-router-dom";

function FeedbackSupport() {
  return (
    <div>
      <Header />
      <div className="container mx-auto sm:px-2 sm:p-24">
        <div className="mt-10 sm:-mt-12">
          <div className="md:grid md:grid-cols-1 md:gap-6"></div>
          <div className="md:col-span-1">
            <div className="px-4 sm:px-0">
              <h3 className="text-lg font-medium max-w-prose text-gray-500">
                <Link to="/mentor/dashboard">Account</Link> &nbsp; &gt; &nbsp;
                Feedback & Support
              </h3>
              <h3 className="text-3xl mt-4 font-bold leading-relaxed text-gray-900">
                Feedback & Support
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div class="container mx-auto px-4 sm:px-2 sm:-mt-16 mt-4">
        {/* <div className="flex space-x-4">
          <div class="bg-blue-600 pt-1 px-2 bg-gradient-to-b from-blue-400 to-blue-500 rounded-xl shadow-lg w-52">
            <div class="flex justify-center">
              <div class="flex justify-center p-4 bg-blue-400 ring-2 mt-2 ring-blue-300 rounded-lg shadow-xl w-32">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="white"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </div>
            </div>
            <div class="p-4">
              <p class="text-white font-semibold">Chat Support</p>
            </div>
          </div>
          <div class="bg-blue-600 pt-1 px-2 bg-gradient-to-b from-blue-400 to-blue-500 rounded-xl shadow-lg w-52">
            <div class="flex justify-center">
              <div class="flex justify-center p-4 bg-blue-400 ring-2 ring-blue-300 rounded-lg shadow-xl w-32 mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="white"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
                  />
                </svg>
              </div>
            </div>
            <div class="p-4">
              <p class="text-white font-semibold">Mail Us</p>
            </div>
          </div>
        </div> */}
        <section class="text-gray-600 body-font">
          <div class="container px-5 sm:px-0 mx-auto">
            <div class="flex flex-wrap -m-4 text-center">
              <div class="sm:p-4 mt-2 sm:mt-0 md:w-1/4 sm:w-1/2 w-full">
                <a
                  href="https://discord.com/invite/V9TYRUbVrV"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div class="border-2 border-gray-200 px-2 py-6 rounded-lg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="text-blue-500 w-12 h-12 mb-3 inline-block"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                      />
                    </svg>
                    <h2 class="title-font font-medium text-xl text-gray-900">
                      Chat Support
                    </h2>
                  </div>
                </a>
              </div>
              <a
                href="mailto:hellodevcolony@gmail.com?subject=support: I need help with my account"
                target="_blank"
                rel="noreferrer"
                class="sm:p-4 mt-4 sm:mt-0 md:w-1/4 sm:w-1/2 w-full"
              >
                <div class="border-2 border-gray-200 px-4 py-6 rounded-lg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    className="text-blue-500 w-12 h-12 mb-3 inline-block"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"
                    />
                  </svg>
                  <h2 class="title-font font-medium text-xl text-gray-900">
                    Mail us
                  </h2>
                </div>
              </a>
            </div>
          </div>
        </section>
        <div class="rounded-lg bg-blue-400 text-white p-8 my-8 flex flex-col md:flex-row space-between items-center justify-between relative overflow-hidden">
          <div class="flex flex-col lg:ml-14 xl:ml-20 max-w-sm lg:max-w-xl z-10">
            <h4 class="text-4xl text-center md:text-left font-bold text-white md:pb-2">
              You need more information?
            </h4>
            <p class="text-center md:text-left text-white opacity-70 md:pb-6 mt-4 sm:mt-0">
              Everything you need to know so you can use Dev Colony like a pro
            </p>
            <p class="text-xs text-white hidden md:block">
              Read Frequently Asked Questions
            </p>
          </div>

          <div class="pt-8 md:pt-0 justify-center lg:ml-auto z-10">
            <a
              href="/faq"
              class="flex items-center px-8 py-4 text-center text-sm text-blue-500 uppercase bg-white font-display rounded-full transition duration-200 hover:bg-gray-100 hover:text-blue-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 mr-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                />
              </svg>
              <span className="">Read FAQs</span>
            </a>
          </div>

          <p class="pt-8 text-xs block md:hidden z-10 text-white">
            Read Frequently Asked Questions
          </p>

          <div class="absolute bg-blue-600 opacity-60 w-96 h-96 -top-10 -right-16 md:w-[800px] md:h-[800px] md:left-[45%] md:top-[-150%] rounded-full shadow-2xl z-0"></div>
        </div>
      </div>
    </div>
  );
}

export default FeedbackSupport;
